(function () {

  'use strict';

  function pxPrinterPropertiesSelectNetwork($timeout, NetworkListService, NetworkListPOSTPaging, CopilotService) {
    return {
      restrict: 'EA',
      scope: {
        me: '=',
        networkName: '=networkName',
        callback: '&'
      },
      templateUrl: 'app/components/printerPropertiesMulti/printerPropertiesSelectNetwork/printerPropertiesSelectNetwork.template.html',
      link: function (scope) {

        scope.loading = false;
        scope.paging = new NetworkListPOSTPaging();
        scope.networks = [];
        scope.totalPages = 0;
        scope.scrollTimeout = null;

        if (scope.networkName) {
          scope.paging.pagingCriteria.match = scope.networkName;
        }

        scope.textSearch = function () {
            getFirstPageOfNetworks();
        };

        scope.selectNetwork = function (event, network) {
          event?.stopPropagation();
          scope.callback({ network: network });
        };

        scope.closePopup = function (event) {
          scope.callback();
        };

        function getFirstPageOfNetworks() {
          scope.loading = true;
          scope.paging.pagingCriteria.page = 0;
          scope.paging.pagingCriteria.pageSize = 10;
          scope.networks = [];
          NetworkListService.getNetworkListPagedByPost(scope.paging).then(function (response) {
            scope.networks = response.list;
            scope.totalPages = response.page.totalPages;
            scope.loading = false;
            if (scope.networkName) {
              // If only one network is found, verify the name matches exactly and if so, select it.
              if (scope.networks.length === 1 && scope.networks[0].info.name === scope.paging.pagingCriteria.match) {
                scope.selectNetwork(null, scope.networks[0]);
              }
            }
          }).catch(function (response) {
            scope.loading = false;
            console.error('Failed to load first page of networks.');
          });
        }

        function getNextPageOfNetworks() {
          if (!scope.loading && scope.totalPages > scope.paging.pagingCriteria.page + 1) {
            scope.loading = true;
            scope.paging.pagingCriteria.page += 1;
            NetworkListService.getNetworkListPagedByPost(scope.paging).then(function (response) {
              scope.networks.push(...response.list);
              scope.totalPages = response.page.totalPages;
              scope.loading = false;
            }).catch(function (response) {
              scope.loading = false;
              console.error('Failed to load next page of networks.');
            });
          }
        }

        function attachScrollHandler() {
          angular.element('.pagination-small-results').on('scroll', scrollHandler);
        }

        function detachScrollHandler() {
          angular.element('.pagination-small-results').off('scroll', scrollHandler);
        }

        function scrollHandler(event) {
          if (!scope.loading && scope.totalPages > scope.paging.pagingCriteria.page + 1) {
            const element = event.currentTarget;
            if (Math.abs(element.scrollHeight - element.clientHeight - element.scrollTop) <= 1) {
              if (scope.scrollTimeout) {
                $timeout.cancel(scope.scrollTimeout);
              }
              scope.scrollTimeout = $timeout(function () {
                scope.scrollTimeout = null;
                getNextPageOfNetworks();
              }, 300);
            }
          }
        }

        (function () {
          attachScrollHandler();
          scope.$on('$destroy', function () {
            detachScrollHandler();
          });
        })();

        scope.$watch(function () {
          return scope.me;
        }, function () {
          getFirstPageOfNetworks();
        });

      }
    };
  }

  pxPrinterPropertiesSelectNetwork.$inject = ['$timeout', 'NetworkListService', 'NetworkListPOSTPaging', 'CopilotService'];

  angular
    .module('printix-admin')
    .directive('pxPrinterPropertiesSelectNetwork', pxPrinterPropertiesSelectNetwork);

})();
